module.exports = __webpack_public_path__ + "img/bonuses.96a18a17.svg";